import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { PolicySelectBoxProps, SelectItem } from '@/pages/policy/interface';

const PolicySelectBox = ({ selectItems }: PolicySelectBoxProps) => {
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState<boolean>(false); // select-list의 열림/닫힘 상태
	const [selectedDate, setSelectedDate] = useState<string>(selectItems[0]?.text || ''); // 선택된 시행 일자

	const toggleSelectList = () => {
		setIsOpen(!isOpen); // select-list 열기/닫기
	};

	const handleSelectDate = (item: SelectItem) => {
		const { text, link } = item;
		navigate(link);
		setSelectedDate(text); // 선택된 시행 일자 업데이트
		setIsOpen(false); // 선택 후 목록 닫기
	};

	useEffect(() => {
		setSelectedDate(selectItems[0]?.text || ''); // 초기 시행 일자 설정
	}, [selectItems]);

	return (
		<div className="terms-history">
			<div
				className="select-wrap"
				tabIndex={0}
				onClick={toggleSelectList} // 클릭 시 select-list 열기/닫기
			>
				<span className="select-label">시행 일자 : {selectedDate}</span>
				{isOpen && (
					// style={{ display: 'block' }} 코드 추가 추후 select-list 스타일 수정 필요
					<ul className="select-list" style={{ display: 'block' }}>
						{selectItems.map((item, index) => (
							<li
								key={index}
								onClick={() => {
									handleSelectDate(item);
								}}>
								<a>시행 일자 : {item.text}</a>
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	);
};

export default PolicySelectBox;
